import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=49b9c5ae&scoped=true"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"
import style0 from "./ProductCategories.vue?vue&type=style&index=0&id=49b9c5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b9c5ae",
  null
  
)

export default component.exports